import React from 'react';
import Immutable from 'immutable';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import {
  Container,
  WysiwygField,
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  CoreLink,
} from '@uncinc/react-drupal-core';

import { DEFAULT_LANGUAGE } from '../../../../config/constants';

import './style.scss';

const NodeProduct = ({ entity }) => {
  const { t } = useTranslation();
  const currentLanguage = useSelector((state) => state.getIn(['ui', 'language'], DEFAULT_LANGUAGE));

  const title = entity.getIn(['title', 0, 'value']);
  const body = entity.getIn(['body', 0, 'processed'], '');
  const alternativeNames = entity.getIn(['field_alternative_name'], Immutable.List());
  const material = entity.getIn(['field_material'], Immutable.List());
  const imgSrc = entity.getIn(['field_media', 0, 'styles', 'image_paragraph']);
  const imgAlt = entity.getIn(['field_media', 0, 'alt']);

  const isPackage = entity.getIn(['field_packaging', 0, 'value'], false);
  const isSingleUsePlastic = entity.getIn(['field_single_use_plastic', 0, 'value'], false);
  const isPOSPackage = entity.getIn(['field_pos_packaging', 0, 'value'], false);
  const isDepositPackage = entity.getIn(['field_deposit_packaging', 0, 'value'], false);
  const isReusablePackage = entity.getIn(['field_reusable_packaging', 0, 'value'], false);
  const isLogisticTool = entity.getIn(['field_logistics_tool', 0, 'value'], false);
  const isPackageProduct = entity.getIn(['field_packaged_product', 0, 'value'], false);
  const isPackageComponent = entity.getIn(['field_component_packaging', 0, 'value'], false);
  const isContributionObligation = entity.getIn(['field_contribution_obligation', 0, 'value'], false);
  const isPackageSpecial = entity.getIn(['field_special_packaging', 0, 'value'], false);

  const note = entity.getIn(['field_note', 0, 'value']);
  const similarCases = entity.getIn(['field_similar_cases'], Immutable.List());

  return (
    <Container className="NodeProduct">
      <div className="row">
        <div className="col-12 col-md-6">
          <h1 className="NodeProduct__title">{title}</h1>
          <div className="NodeProduct__alternative_names">
            {alternativeNames.map((alternativeName, index) => {
              const alternativeNameName = alternativeName.get('value');

              return (
                <div key={alternativeNameName}>{alternativeNameName}{alternativeNames.size - 1 > index && ', '}</div>
              );
            })}
          </div>

          <WysiwygField
            className="NodeProduct__body"
            property="schema:text"
            html={body}
          />

          <div className="NodeProduct__materials">
            {material.map((item) => {
              const itemTitle = item.getIn(['entity', 'name', 0, 'value']);
              const path = item.getIn(['entity', 'paths', currentLanguage]);
              if (itemTitle) {
                return (
                  <CoreLink className="NodeProduct__type" key={title} to={path}>{itemTitle}</CoreLink>
                );
              }
              else {
                return (
                  <div className="NodeProduct__type" key={title}>{t('other_product')}</div>
                );
              }
            })}
          </div>

          <Image
            className="NodeProduct__image"
            src={imgSrc}
            alt={imgAlt}
          />


        </div>

        <div className="col-12 col-md-6 col-lg-5 offset-lg-1">
          {/* TODO: Make me an i18n key */}
          <h2>{t('product.information')}</h2>

          <div className="NodeProduct__information">
            <div className="NodeProduct__information__item">
              <div className="NodeProduct__information__item__title">
                {t('product.isPackage')}
              </div>
              <div className="NodeProduct__information__item__checkmark">
                <div className={`icon icon-${isPackage ? 'checkmark' : 'cross'} icon-variant-2`} />
              </div>
            </div>
            <div className="NodeProduct__information__item">
              <div className="NodeProduct__information__item__title">
                {t('product.isContributionObligation')}
              </div>
              <div className="NodeProduct__information__item__checkmark">
                <div className={`icon icon-${isContributionObligation ? 'checkmark' : 'cross'} icon-variant-2`} />
              </div>
            </div>
            <div className="NodeProduct__information__item">
              <div className="NodeProduct__information__item__title">
                {t('product.isSingleUsePlastic')}
              </div>
              <div className="NodeProduct__information__item__checkmark">
                <div className={`icon icon-${isSingleUsePlastic ? 'checkmark' : 'cross'} icon-variant-2`} />
              </div>
            </div>
            <div className="NodeProduct__information__item">
              <div className="NodeProduct__information__item__title">
                {t('product.isPOSPackage')}
              </div>
              <div className="NodeProduct__information__item__checkmark">
                <div className={`icon icon-${isPOSPackage ? 'checkmark' : 'cross'} icon-variant-2`} />
              </div>
            </div>
            <div className="NodeProduct__information__item">
              <div className="NodeProduct__information__item__title">
                {t('product.isDepositPackage')}
              </div>
              <div className="NodeProduct__information__item__checkmark">
                <div className={`icon icon-${isDepositPackage ? 'checkmark' : 'cross'} icon-variant-2`} />
              </div>
            </div>
            <div className="NodeProduct__information__item">
              <div className="NodeProduct__information__item__title">
                {t('product.isReusablePackage')}
              </div>
              <div className="NodeProduct__information__item__checkmark">
                <div className={`icon icon-${isReusablePackage ? 'checkmark' : 'cross'} icon-variant-2`} />
              </div>
            </div>
            <div className="NodeProduct__information__item">
              <div className="NodeProduct__information__item__title">
                {t('product.isLogisticTool')}
              </div>
              <div className="NodeProduct__information__item__checkmark">
                <div className={`icon icon-${isLogisticTool ? 'checkmark' : 'cross'} icon-variant-2`} />
              </div>
            </div>
            <div className="NodeProduct__information__item">
              <div className="NodeProduct__information__item__title">
                {t('product.isPackageProduct')}
              </div>
              <div className="NodeProduct__information__item__checkmark">
                <div className={`icon icon-${isPackageProduct ? 'checkmark' : 'cross'} icon-variant-2`} />
              </div>
            </div>
            <div className="NodeProduct__information__item">
              <div className="NodeProduct__information__item__title">
                {t('product.isPackageComponent')}
              </div>
              <div className="NodeProduct__information__item__checkmark">
                <div className={`icon icon-${isPackageComponent ? 'checkmark' : 'cross'} icon-variant-2`} />
              </div>
            </div>
            <div className="NodeProduct__information__item">
              <div className="NodeProduct__information__item__title">
                {t('product.isPackageSpecial')}
              </div>
              <div className="NodeProduct__information__item__checkmark">
                <div className={`icon icon-${isPackageSpecial ? 'checkmark' : 'cross'} icon-variant-2`} />
              </div>
            </div>
          </div>
          {note && (
            <div className="NodeProduct__note">
              <h4>{t('product.note')}</h4>
              {note}
            </div>
          )}
          {similarCases && similarCases.size > 0 && (
            <div className="NodeProduct__similar_cases">
              <h4>{t('product.similar_cases')}</h4>

              {similarCases.map((similarCase, index) => {
                const similarCaseName = similarCase.get('value');

                return (
                  <div key={similarCaseName}>{similarCaseName}{similarCases.size - 1 > index && ', '}</div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </Container>
  );
};

export default NodeProduct;
